import { render, staticRenderFns } from "./wsNoContentInfo.vue?vue&type=template&id=1e6e6d92&scoped=true&"
import script from "./wsNoContentInfo.vue?vue&type=script&lang=js&"
export * from "./wsNoContentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e6d92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
